<template>
    <div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <!-- <h3 class="card-title">KORISNIK</h3> -->
                        <h3 class="card-title">Korisnicko ime: {{ user.userName }}</h3>
                        <h3><base-input label="Lozinka" type="text" v-model="user.pwd"
                            placeholder="Lozinka">
                        </base-input></h3>
                        <h3><base-input label="Ponovite lozinku" type="text" v-model="user.pwd2"
                            placeholder="Lozinka">
                        </base-input></h3>
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="changePassword()">Promeni</base-button>

                    </template>


                    
                </card>
            </div>

            
        </div>
        
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getCurrentUser()
        // this.getUsers()
        // this.getEmployees()
        // this.getKiosks()
        // this.getRegions()
        // this.getRoles()
    },
    data() {
        return {
            activeName: 'first',
            sectors: [],
            url: 'https://budva.scancar.org:8443/kuca',
            user: {},
            loading: false
        };
    },
    methods: {
        
        getCurrentUser() {
            this.zonesLoading = true
            axios.get(this.url + '/user/getUser').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.user = result.data.user
                    // alert(this.user.userName)
                } else {

                }
            })
        },
        changePassword() {
            this.loading = true
            axios.post(this.url + '/user/changePassword', this.user).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getCurrentUser()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>